import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX, STORAGE_KEYS } from 'utils/constants';
import { ENUM_CATEGORY } from 'utils/enum';

const UnauthRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const cat = localStorage.getItem(STORAGE_KEYS.CATEGORY) as ENUM_CATEGORY;
  const routePrefix = cat === ENUM_CATEGORY.FOOD ? ROUTE_PREFIX.FOOD : ROUTE_PREFIX.SHOP;

  return !token ? children : <Navigate to={`${routePrefix}/${ROUTE_KEYS.OVERVIEW}`} />;
};
export default UnauthRoute;
